import { Button, Dropdown, Menu } from 'antd'
import * as React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import {
  useCurrentInvoice,
  useCurrentSupportedAssets,
  useCreatePayment,
} from './queries'
import styled from 'styled-components'

const ItemInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
`

export const SelectExchangeRate = ({
  provider,
  icon,
  children,
}: {
  provider: 'SMT' | 'MPGS' | 'PAYPAL' | 'SOBFLOUS' | 'PAYMEE'
  icon?: React.ReactNode
  children?: React.ReactNode
}) => {
  const invoiceQuery = useCurrentInvoice()
  const supportedAssetsQuery = useCurrentSupportedAssets()
  const amount = invoiceQuery.data?.amount ?? 0
  const createPaymentMutation = useCreatePayment()

  const handleClick = React.useCallback(
    ({ key }: { key: string }) => {
      createPaymentMutation?.mutate({
        currency: key,
        method: provider,
      })
    },
    [createPaymentMutation, provider]
  )

  return (
    <Dropdown
      disabled={(supportedAssetsQuery.data?.[provider]?.length ?? 0) === 0}
      overlay={
        <Menu onClick={handleClick}>
          {supportedAssetsQuery.data?.[provider].map(xr => (
            <Menu.Item key={xr.currency}>
              <ItemInner>
                <div>
                  <FormattedMessage
                    id="payInCurrency"
                    values={{ currency: xr.currency }}
                  />
                </div>
                <div>
                  <FormattedNumber
                    value={(xr.numerator * amount) / xr.denominator}
                    style="currency"
                    currency={xr.currency}
                  />
                </div>
              </ItemInner>
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button
        icon={icon}
        disabled={(supportedAssetsQuery.data?.[provider]?.length ?? 0) === 0}
        loading={
          supportedAssetsQuery.isLoading ||
          invoiceQuery.isLoading ||
          createPaymentMutation?.isLoading
        }
        type="primary"
      >
        {children}
      </Button>
    </Dropdown>
  )
}
